export default {
    api: process.env.API,
    static: process.env.STATIC
}